
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/management-liability",
      function () {
        return require("private-next-pages/management-liability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/management-liability"])
      });
    }
  